import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { PdInput } from "../pd-input/PdInput.js";
import { html } from "lit";
import { property } from "lit/decorators.js";
import { pdIcons } from "@progressive-development/pd-icon";
import "@progressive-development/pd-icon/pd-icon";
import { localized, msg } from "@lit/localize";
//#region src/pd-input-password/PdInputPassword.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var PdInputPassword = class PdInputPassword extends PdInput {
	constructor() {
		super();
		this.revealable = false;
		this.secret = true;
	}
	/** Whether the password is currently shown as plain text. */
	get _revealed() {
		return !this.secret;
	}
	willUpdate(changed) {
		super.willUpdate(changed);
		if (changed.has("revealable")) this.toggleAttribute("icon-right", this.revealable);
	}
	/** Toggles the reveal state and notifies listeners. */
	_toggleReveal() {
		if (this.disabled || this.readonly) return;
		this.secret = !this.secret;
		this.dispatchEvent(new CustomEvent("password-reveal-toggle", {
			detail: { revealed: this._revealed },
			bubbles: true,
			composed: true
		}));
	}
	_onRevealKeyDown(event) {
		if (event.key === " " || event.key === "Enter") {
			event.preventDefault();
			this._toggleReveal();
		}
	}
	_renderFieldIcon() {
		if (!this.revealable) return super._renderFieldIcon();
		const label = this._revealed ? msg("Passwort verbergen", { id: "pd.input.password.hide" }) : msg("Passwort anzeigen", { id: "pd.input.password.show" });
		return html`
      <pd-icon
        icon="${pdIcons.ICON_EYE}"
        ?activeIcon="${this._revealed}"
        ?disabled="${this.disabled}"
        class="infield-icon"
        tabindex="${this.disabled ? -1 : 0}"
        role="button"
        aria-label="${label}"
        aria-pressed="${this._revealed ? "true" : "false"}"
        @click="${this._toggleReveal}"
        @keydown="${this._onRevealKeyDown}"
      ></pd-icon>
    `;
	}
};
__decorate([property({ type: Boolean })], PdInputPassword.prototype, "revealable", void 0);
PdInputPassword = __decorate([localized()], PdInputPassword);
//#endregion
export { PdInputPassword };
